import Css from "./style.module.scss";

import Activity from "nlib/common/Activity";
import CommentTargetTypes from "const/CommentTargetTypes";
import React from "react";

const ActivityTab = ({ disabled, documentData }) => {
  return (
    <div className={Css.activityTab}>
      <Activity
        showAllInitial
        disabled={disabled}
        itemId={documentData.id}
        type={CommentTargetTypes.DOCUMENTS}
        commentsCount={documentData.comments} />
    </div>
  );
};

export default React.memo(ActivityTab);
